"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var form_radio_group_1 = __importDefault(require("bootstrap-vue/es/components/form-radio/form-radio-group"));
var ConditionalDisplay_1 = __importDefault(require("../../Mixins/ConditionalDisplay"));
var PredicateInput_1 = __importDefault(require("../../Mixins/PredicateInput"));
var SourceValue_1 = __importDefault(require("../../Mixins/SourceValue"));
exports.default = vue_1.default.extend({
    props: ['name', 'label', 'required', 'options', 'inline'],
    components: { bFormRadioGroup: form_radio_group_1.default },
    mixins: [ConditionalDisplay_1.default, PredicateInput_1.default, SourceValue_1.default],
    data: function () {
        var model = this.$root.$data;
        return {
            optionsObject: this.options || [],
            readonly: model.readOnly
        };
    },
    methods: {
        getClass: function (isrb) {
            return !this.inline ? "col-12 " : isrb ? "pt-2 ml-3 " : "";
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/Input/RadioButton.vue
// module id = 200
// module chunks = 0